import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'oaibox-modulation-order-create-configuration',
    templateUrl: './modulation-order-create-configuration.component.html',
    styleUrls: ['./modulation-order-create-configuration.component.css'],
    imports: [ReactiveFormsModule]
})
export class ModulationOrderUSRPCreateConfigurationComponent {

  @Input() public defaultModulationOrderOptions?: string[];
  @Input() public editableModulationOrderOptions?: string[];
  @Output() public optionsChange: EventEmitter<string[]> = new EventEmitter();

  public modulationOrderOptionsForm: FormGroup;

  constructor() {
    this.modulationOrderOptionsForm = new FormGroup({
      modulationOrder: new FormControl(undefined, Validators.required),
    });
  }

  public addModulationOrderOption(): void {
    if (!this.editableModulationOrderOptions) this.editableModulationOrderOptions = [];
    this.editableModulationOrderOptions.push(this.modulationOrderOptionsForm.value.modulationOrder);
    this.optionsChange.emit(this.editableModulationOrderOptions);
    this.modulationOrderOptionsForm.reset();
  }

  public removeModulationOrderOption(index: number): void {
    this.editableModulationOrderOptions?.splice(index, 1);
    this.optionsChange.emit(this.editableModulationOrderOptions);
  }

}
